import { z } from "zod/v4-mini";

import { cz } from "@/utils/zodUtils.ts";

export type PatientInfo = {
  givenName: string;
  familyName: string;
  email: string;
  phone: string;
  helperPhone?: string;
};

export const patientInfoSchema = z.object({
  givenName: z.string("form.required").check(z.minLength(1, "form.required")),
  familyName: z.string("form.required").check(z.minLength(1, "form.required")),
  email: z.email("form.email.invalid"),
  phone: cz.phone({ string: "form.required", refine: "form.phone.invalid" }),
  helperPhone: z.optional(cz.phone({ refine: "form.phone.invalid" })),
});
